export default "__VITE_ASSET__253ab1eb__"